import React from 'react';
import CrudPage from '../../components/CrudPage';
import { treeApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'treeId' },
  { header: 'Tree Name', field: 'treeName' },
  { header: 'Forest ID', field: 'forestId' },
  { header: 'Species', field: 'species' },
  { header: 'Planted', field: 'plantedDate', type: 'date' },
];

const formFields = [
  { name: 'treeName', label: 'Tree Name', type: 'text', required: true },
  { name: 'forestId', label: 'Forest ID', type: 'number', required: true },
  { name: 'species', label: 'Species', type: 'text' },
  { name: 'description', label: 'Description', type: 'textarea' },
  { name: 'plantedDate', label: 'Planted Date', type: 'date' },
  { name: 'imageUrl', label: 'Image URL', type: 'text' },
];

const TreePage = () => (
  <CrudPage
    title="Trees"
    subtitle="Manage EcoVest trees"
    api={treeApi}
    columns={columns}
    formFields={formFields}
    idField="treeId"
    searchField="treeName"
  />
);

export default TreePage;
